<template>
  <h2>Modalidades</h2>
  <div class="row">
    <div class="col-12">
      <nav id="tabs" class="nav">
        <a class="nav-link active" @click="selectedTab = 1" :class="selectedTab == 1 ? 'active' : ''">Listagem</a>
      </nav>
      <div v-show="loading">Carregando...</div>
      <table class="styled-table" v-show="!loading">
        <thead>
          <tr>
            <th style="width: 140px"> <input type="text" v-model="quickFilter" class="form-control"
                style="height: 26px; float: left;" placeholder="Pesquisar" autocomplete="off" />
            </th>
            <th><span style="margin-left: -140px;"> Nome</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="m in modalities" :key="m.id"
            v-show="quickFilter == '' || m.name.toUpperCase().match(quickFilter.toUpperCase())">
            <td colspan="2">{{ m.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mainService from "@/services/mainService";
import { toast } from "@/composables/useToast";
import { handleErrorMessage } from "@/services/config";
export default {
  data: () => ({
    quickFilter: "",
    modalities: [],
    loading: false,
  }),
  mounted() {
    this.searchModalities();
  },
  methods: {
    searchModalities() {
      this.loading = true;
      mainService
        .searchModalities()
        .then((response) => {
          this.modalities = response.data;
        })
        .catch((error) => {
          toast.error(handleErrorMessage(error));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
